var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-sm btn-filter-followup",class:_vm.isActive ? 'btn-primary' : 'btn-outline-secondary',attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('input', !_vm.isActive)}}},[_c('i',{staticClass:"fa mr-1",class:_vm.isActive ? 'fa-check-square' : 'fa-square-o'}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }